/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Other_EventInputs */



/**
* | output |
* | --- |
* | "Other event" |
*
* @param {Sanction_Other_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_other_event = /** @type {((inputs?: Sanction_Other_EventInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Other_EventInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autre événement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Otro evento")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Outro evento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Altro evento")
	return /** @type {LocalizedString} */ ("Other event")
});